import { useAxios } from '@/hooks/useAxios';
import { Schema } from '@/types';
import { useQuery } from '@/utils/api';

export const useGetSchema = () => {
  const axios = useAxios();

  return useQuery<Schema>({
    queryKey: ['schema'],
    queryFn: async () => {
      const { data } = await axios.get<Schema>('/schema');
      return data;
    },
    staleTime: Infinity, // Schema is considered static for the session
    defaultErrorMessage: 'Failed to fetch schema',
  });
};
